import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import App from './app'

class AppRoute extends React.Component {
    render() {
        return <>
            <Switch>
                <Route path="/" exact render={
                    () => <App />
                } ></Route>
                <Route path="/phone" exact render={
                    () => <App />
                } ></Route>
            </Switch>
        </>
    }
}

export default AppRoute